import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/shape1.png'
import _imports_1 from '../../../assets/img/shape2.svg'
import _imports_2 from '../../../assets/img/shape3.svg'
import _imports_3 from '../../../assets/img/shape4.svg'
import _imports_4 from '../../../assets/img/shape5.png'
import _imports_5 from '../../../assets/img/courses/logo-html5-css3.png'
import _imports_6 from '../../../assets/img/courses/JavaScript-Logo.png'
import _imports_7 from '../../../assets/img/courses/mysql.jpg'
import _imports_8 from '../../../assets/img/courses/Logo-Vuejs.png'
import _imports_9 from '../../../assets/img/courses/2048px-Angular_full_color_logo.png'
import _imports_10 from '../../../assets/img/courses/1200px-Node.js_logo.png'


const _hoisted_1 = { class: "agency-services-area ptb-80" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6 col-md-6" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  href: "#",
  class: "read-more-btn"
}
const _hoisted_7 = { class: "col-lg-4 col-sm-6 col-md-6" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  href: "#",
  class: "read-more-btn"
}
const _hoisted_10 = { class: "col-lg-4 col-sm-6 col-md-6" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  href: "#",
  class: "read-more-btn"
}
const _hoisted_13 = { class: "col-lg-4 col-sm-6 col-md-6" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = {
  href: "#",
  class: "read-more-btn"
}
const _hoisted_16 = { class: "col-lg-4 col-sm-6 col-md-6" }
const _hoisted_17 = { class: "content" }
const _hoisted_18 = {
  href: "",
  class: "read-more-btn"
}
const _hoisted_19 = { class: "col-lg-4 col-sm-6 col-md-6" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = {
  href: "#",
  class: "read-more-btn"
}

import { useHead } from '@vueuse/head';
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesProgrammation',
  setup(__props) {

const router = useRouter();

const goPage = (url:any) => {
  router.push(url);
}


useHead({
  title: 'PROGRAMMATION - IT+ CODE LAB',
  meta: [
    { name: 'description', content: 'Consultez la liste de nos formations en programmation | Code Lab | Cours et Formations en informatique à Djibouti' }
    ,{ name: 'keywords', content: 'formation,Code Lab,formations,angular,vue, html, css,linux,sécurité,javascript, java, informatique,djibouti, Djibouti, programmation, réseaux, cours, codelab, it+' }
    ]
})



return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"page-title-area\"><div class=\"d-table\"><div class=\"d-table-cell\"><div class=\"container\"><h2>Cours et formations en programmation informatique</h2></div></div></div><div class=\"shape1\"><img src=\"" + _imports_0 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape3\"><img src=\"" + _imports_2 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape5\"><img src=\"" + _imports_4 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape6 rotateme\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "agency-services-box",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage('/cours-programmation/html-css')))
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                src: _imports_5,
                alt: "IT+ Code Lab"
              }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/cours-programmation/html-css" }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("h3", null, [
                      _createElementVNode("a", { href: "#" }, "HTML et CSS")
                    ], -1)),
                    _createElementVNode("a", _hoisted_6, [
                      _cache[6] || (_cache[6] = _createTextVNode("Lire plus ")),
                      _createVNode(_component_vue_feather, { type: "plus-circle" })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "agency-services-box",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goPage('/cours-programmation/javascript')))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("img", {
                src: _imports_6,
                alt: "IT+ Code Lab"
              }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/cours-programmation/javascript" }, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("h3", null, [
                      _createElementVNode("a", { href: "#" }, "Javascript")
                    ], -1)),
                    _createElementVNode("a", _hoisted_9, [
                      _cache[9] || (_cache[9] = _createTextVNode("Lire plus ")),
                      _createVNode(_component_vue_feather, { type: "plus-circle" })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "agency-services-box",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goPage('/cours-programmation/mysql')))
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_7,
                alt: "IT+ Code Lab"
              }, null, -1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, { to: "/cours-programmation/mysql" }, {
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createElementVNode("h3", null, [
                      _createElementVNode("a", { href: "#" }, "MySQL")
                    ], -1)),
                    _createElementVNode("a", _hoisted_12, [
                      _cache[12] || (_cache[12] = _createTextVNode("Lire plus ")),
                      _createVNode(_component_vue_feather, { type: "plus-circle" })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "agency-services-box",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goPage('/cours-programmation/vue')))
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("img", {
                src: _imports_8,
                alt: "IT+ Code Lab"
              }, null, -1)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, { to: "/cours-programmation/vue" }, {
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("h3", null, [
                      _createElementVNode("a", { href: "#" }, "Vue.js")
                    ], -1)),
                    _createElementVNode("a", _hoisted_15, [
                      _cache[15] || (_cache[15] = _createTextVNode("Lire plus ")),
                      _createVNode(_component_vue_feather, { type: "plus-circle" })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "agency-services-box",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goPage('/cours-programmation/angular')))
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("img", {
                src: _imports_9,
                alt: "IT+ Code Lab"
              }, null, -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_router_link, { to: "/cours-programmation/angular" }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("h3", null, [
                      _createElementVNode("a", { href: "#" }, "Angular")
                    ], -1)),
                    _createElementVNode("a", _hoisted_18, [
                      _cache[18] || (_cache[18] = _createTextVNode("Lire plus ")),
                      _createVNode(_component_vue_feather, { type: "plus-circle" })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "agency-services-box",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (goPage('/cours-programmation/node')))
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("img", {
                src: _imports_10,
                alt: "IT+ Code Lab"
              }, null, -1)),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_router_link, { to: "/cours-programmation/node" }, {
                  default: _withCtx(() => [
                    _cache[22] || (_cache[22] = _createElementVNode("h3", null, [
                      _createElementVNode("a", { href: "#" }, "Node.js")
                    ], -1)),
                    _createElementVNode("a", _hoisted_21, [
                      _cache[21] || (_cache[21] = _createTextVNode("Lire plus ")),
                      _createVNode(_component_vue_feather, { type: "plus-circle" })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape3\"><img src=\"" + _imports_2 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape6 rotateme\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div>", 6))
    ])
  ]))
}
}

})